import type { PageProps, PaymentChannelsPageProps } from "@/types";
import React, { FC } from "react";
import {
  PaymentChannelsDetermineCorridors,
  PaymentChannelsGrowYourBusiness,
  PaymentChannelsHero,
  PaymentChannelsMaintainTheIntegrity,
  PaymentChannelsTags,
} from "../payment-channels";
import { NextPage } from "../next-page";

export const PaymentChannels: FC<PageProps<PaymentChannelsPageProps>> = (
  props
) => {
  return (
    <div>
      <PaymentChannelsHero
        label="Payment Channels"
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
      />
      <PaymentChannelsTags
        title={props.data.tagsTitle}
        tags={props.data.tags}
        description={props.data.tagsDescription}
      />
      <PaymentChannelsGrowYourBusiness
        content={props.data.growYourBusinessContent}
        card={props.data.growYourBusinessCard}
      />
      <PaymentChannelsMaintainTheIntegrity
        content={props.data.maintainTheIntegrityContent}
        cover={props.data.maintainTheIntegrityCover}
      />
      <PaymentChannelsDetermineCorridors
        content={props.data.determineCorridorsContent}
        cover={props.data.determineCorridorsCover}
      />
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
